module.exports = __webpack_public_path__ + "static/media/cuisine.ee94f1af.jpg";